import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

import types, {keysKey} from './types';
import {Action, handleAsyncActions} from '../helpers';

export const keysInitialState = {
   isFetching: false,
   error: null,
};

const reducer = (_state = keysInitialState, action: Action) => {
   const state = handleAsyncActions(_state, action, types);

   switch (action.type) {
      default:
         return state;
   }
};

let _reducer = reducer;
if (process.env.REACT_APP_PERSISTED === 'true') {
   const config = {
      key: keysKey,
      storage: storage,
      blacklist: ['error', 'isFetching'],
   };
   _reducer = persistReducer(config, reducer) as any;
}
export default _reducer;
